import { z } from "zod";

export const MAX_DASHBOARD_DAYS = 366;

const isoDate = z.iso.date("Use a valid date.");

/** Dashboard range (business days in Australia/Sydney, inclusive). */
export const dashboardQuerySchema = z
  .object({ from: isoDate.optional(), to: isoDate.optional() })
  .refine((range) => !range.from || !range.to || range.from <= range.to, {
    message: "The start date must be on or before the end date.",
    path: ["from"],
  })
  .refine(
    (range) =>
      !range.from ||
      !range.to ||
      (Date.parse(range.to) - Date.parse(range.from)) / 86_400_000 < MAX_DASHBOARD_DAYS,
    { message: `Choose a range of up to ${MAX_DASHBOARD_DAYS} days.`, path: ["to"] },
  );
export type DashboardQuery = z.input<typeof dashboardQuerySchema>;

export const dashboardPresets = [
  { key: "7d", label: "7 days", days: 7 },
  { key: "30d", label: "30 days", days: 30 },
  { key: "90d", label: "90 days", days: 90 },
  { key: "365d", label: "12 months", days: 365 },
] as const;
